import PropTypes from 'prop-types'
import { useContext, useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'

import { GlobalContext } from 'hsds/components/hsds'

const PORTAL_ID = 'hsapp-root'

export const PortalBody = ({
  children,
  onClose,
  onOpen,
  className,
  id = PORTAL_ID,
}) => {
  const { getCurrentScope } = useContext(GlobalContext) || {}
  const scope = getCurrentScope ? getCurrentScope() : null

  const mount = window.document.body

  const el = useMemo(() => {
    const currentEl = id ? document.getElementById(id) : null
    if (currentEl) return currentEl

    const div = document.createElement('div')
    if (scope) div.classList.add(scope)
    if (className) div.classList.add(...className.split(' '))
    if (id) div.id = id

    return div
  }, [scope, id, className])

  useEffect(() => {
    mount.appendChild(el)
    if (onOpen) onOpen()

    return () => {
      const unmount = () => {
        if (onClose) onClose()
        if (mount.contains(el)) mount.removeChild(el)
      }

      unmount()
    }
  }, [el, mount, onClose, onOpen])

  return createPortal(children, el)
}

PortalBody.propTypes = {
  className: PropTypes.string,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
}
